export const formatSocials = (identity: any) => {
  const wallets =
    identity.walletAccounts?.map((wallet: any) => {
      return {
        text: wallet.address,
        type: "wallet",
      };
    }) ?? [];

  const discords =
    identity.discordAccounts?.map((account: any) => {
      return {
        text: account.discordDisplayName,
        type: "discord",
      };
    }) ?? [];

  return [...wallets, ...discords];
};
